import { ValidatorFn, FormGroup, ValidationErrors, AbstractControl } from '@angular/forms';

export class PatternValidator {

  static pattern(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} => {
      const valid = regex.test(control.value);
      // @ts-ignore
      return valid ? null : error;
    };
  }

  static passwordMatchValidator(control: AbstractControl) {
    // @ts-ignore
    const password: string = control.get('new_password').value;
    // @ts-ignore
    const confirmPassword: string = control.get('confirm_password').value;

    if (password !== confirmPassword) {
      // if they don't match, set an error in our confirmPassword form control
      // @ts-ignore
      control.get('confirm_password').setErrors({ NoPassswordMatch: true });
    }
  }
}

